module.exports = __webpack_public_path__ + "static/media/aws_brandmark.acf6dd33.svg";